const Presence = {
    absent: {
        value: 2,
        color: "#d76b6b",
        text: "presence.absent"
    },
    present: {
        value: 1,
        color: "#80de80",
        text: "presence.present"
    },
    excuse: {
        value: 3,
        color: "#5997f3",
        text: "presence.excuse"
    },
    parse: (value) => {
        switch (value) {
            default:
            case Presence.absent.value:
                return Presence.absent;
            case Presence.present.value:
                return Presence.present;
            case Presence.excuse.value:
                return Presence.excuse;
        }
    }
};

export default Presence;
